// extracted by mini-css-extract-plugin
export var AltLight = "microBanner-module--AltLight--885ac";
export var Dark = "microBanner-module--Dark--2b757";
export var Light = "microBanner-module--Light--7c589";
export var microBanner = "microBanner-module--microBanner--54a39";
export var microBannerBgImage = "microBanner-module--microBannerBgImage--ca523";
export var microBannerButton = "microBanner-module--microBannerButton--58ceb";
export var microBannerCopy = "microBanner-module--microBannerCopy--c2e45";
export var microBannerImage = "microBanner-module--microBannerImage--2bd09";
export var microBannerInner = "microBanner-module--microBannerInner--55f75";
export var microBannerMedia = "microBanner-module--microBannerMedia--22950";